import { getOfferInlineMetrics } from '../Components/OfferTable/offerInlineMetrics';
import type { ProdutoDetalhado } from '../hooks/useProdutosCampanha';
import type { IRowData } from '../types/offer.types';

export const buildInitialProductFromOfferRow = (offer: IRowData): ProdutoDetalhado => {
  const { offer_price_cpi } = getOfferInlineMetrics(offer, offer.offer_final_price ?? null);

  return {
    product_id: offer.product_id,
    product_uuid: offer.product_uuid,
    description: offer.description,
    pmz: offer.pmz,
    retail_price: offer.retail_price,
    retail_price_cpi: offer.retail_price_cpi ?? undefined,
    avg_competitiveness_price: offer.avg_competitiveness_price ?? undefined,
    offer_price_cpi: offer_price_cpi ?? undefined,
    margin: offer.margin,
    margin_price_retail: offer.margin_price_retail ?? undefined,
    product_family_id: offer.product_family_id,
    store_id: '',
    cost: offer.cost,
    avg_price: 0,
    category_level1: '',
    category_level2: '',
    category_level3: '',
    category_level4: '',
    client_id: offer.client_id,
  };
};
